// グラフのある画面でだけ chartkick + chart.js を読み込む (#2904)。
//
// 【なぜ分けるか】
// chart.js 2.x は時間軸のために moment を丸ごと抱える。chartkick と合わせて
// 本番ビルドの 1.1MB を占めるが、グラフがあるのは管理画面・放送局管理・
// ダッシュボード・動画詳細のインサイトだけで、未ログインの閲覧者には要らない。
//
// 【chartkick:load を自分で発火している理由】
// chartkick gem が書き出すインラインスクリプトは、その時点で window.Chartkick が
// 無ければ chartkick:load を待つ。pack を defer にした (#2943) ためインラインの方が
// 先に走り、必ずこの待ち状態になる。ところが npm の chartkick 3.2.1 は
// chartkick:load を発火しない (発火するのは 4 以降) ので、待ち続けて
// 「Loading...」のまま止まる。読み込み後にこちらから 1 度だけ発火させて解く。
//
// 2 回目以降の画面遷移では window.Chartkick が既にあるため、インラインスクリプトは
// その場でグラフを作る。イベントを再発火すると、前の画面のリスナが残っていて
// 存在しない要素に対して実行されるので、発火は最初の 1 回だけにしている。
let loading = null;

// chartkick gem のインラインスクリプトは必ず Chartkick を参照する。
// 描画先の id (chart-1 など) を見るより確実
function pageUsesCharts() {
  return Array.from(document.querySelectorAll('script:not([src])'))
    .some((script) => script.textContent.includes('Chartkick'));
}

function loadChartLibrary() {
  if (!loading) {
    loading = import(/* webpackChunkName: "charts" */ './chartLibrary').then(() => {
      window.dispatchEvent(new Event('chartkick:load'));
    });
  }

  return loading;
}

export default function setupCharts() {
  document.addEventListener('turbolinks:load', () => {
    if (pageUsesCharts()) loadChartLibrary();
  });
}
